import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Always mounted; shown and hidden with a CSS transition (was framer's
  // AnimatePresence — kept framer-motion out of the first load, 2026-10-07).
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="חזרה למעלה"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={`fixed bottom-[84px] left-[20px] z-40 hidden md:inline-flex h-11 w-11 items-center justify-center rounded-full border border-[var(--cin-line)] bg-white text-[var(--cin-ink)] shadow-[0_6px_18px_-8px_rgba(15,23,41,0.35)] transition-[opacity,transform,background-color] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-[var(--cin-paper-soft)] active:scale-95 ${
        visible ? 'opacity-100' : 'pointer-events-none translate-y-5 opacity-0'
      }`}
    >
      <ArrowUp className="h-[18px] w-[18px]" aria-hidden="true" />
    </button>
  );
}
